import { RadioGroup, type RadioGroupProps } from '@mui/material'
import type { FC } from 'react'

export const MolsonRadioGroup: FC<RadioGroupProps> = ({
  children,
  ...props
}) => {
  return <RadioGroup {...props}>{children}</RadioGroup>
}
